if (typeof JW === 'undefined') JW = {};
JW.SkufWiz = function ($, mdl)
{
    var $mdl = $(mdl);
    if ($mdl.length === 0) return;

    var step = 0;
    var max_step = 3;
    var skufwiz_authed_1 = $mdl.data('isc') == 1; // login (Mit JOBWOCHE-Konto) — true für Path A ($isc)
    var skufwiz_authed_2 = false;                 // register (Neu anmelden)

    function updateNextBtnState() {
        // On step 2 with a logged-in user (Path A or after a successful login_check),
        // the Weiter button is gated by the data-confirmation checkbox.
        // In all other cases Weiter is always enabled; on step 2 it then triggers
        // login_check / register_check before advancing.
        var enable = true;
        if (step === 2 && skufwiz_authed_1)
        {
            enable = $('#skufwiz_data_confirm').prop('checked');
        }
        $('#skufwiz_next').prop('disabled', !enable).toggleClass('disabled', !enable);
    }

    function showStep(s) {
        step = Math.max(0, Math.min(max_step, s));
        $mdl.find('.skufwiz-step').removeClass('act');
        $mdl.find('.skufwiz-step[data-step="'+step+'"]').addClass('act');
        $mdl.find('#skufwiz_stepper > div').removeClass('act cur bck');
        $mdl.find('#skufwiz_stepper > div').each(function(i) {
            if (i <= step) $(this).addClass('act');
            if (i === step) $(this).addClass('cur');
            if (i < step)  $(this).addClass('bck');
        });
        $('#skufwiz_back').html(step === 0 ? 'Abbrechen' : '<i class="fa fa-chevron-left mr-2"></i>Zurück')
                          .toggleClass('mdl-close-frc', step === 0);
        if (step === max_step) {
            $('#skufwiz_next').addClass('d-none');
            $('#skufwiz_submit').removeClass('d-none');
            updateSummary();
        } else {
            $('#skufwiz_next').removeClass('d-none');
            $('#skufwiz_submit').addClass('d-none');
        }
        updateNextBtnState();
        $mdl.find('[data-toggle="tooltip"]').tooltip({html: true});
        if (JW && JW.Modal && JW.Modal.posMdl) JW.Modal.posMdl($mdl);
    }

    function initJbSelects($container) {
        if (!$container || $container.length === 0) return;
        if (typeof JW === 'undefined' || typeof JW.InpSelect !== 'function') return;
        $container.find('.jb-select:not(.nai)').each(function() {
            if ($(this).find('select').data('InpSelect')) return; // already initialised
            JW.InpSelect(jQuery, this);
        });
    }

    $mdl.on('skufwiz_authed_1', function() {
        skufwiz_authed_1 = true;
        // no auto-advance: user must review/confirm data via #skufwiz_data_confirm first.
        initJbSelects($('#skufwiz_step2_inner'));
        updateNextBtnState();
    });
    $mdl.on('skufwiz_authed_2', function() {
        skufwiz_authed_2 = true;
        updateNextBtnState();
        if (step === 2) showStep(step + 1);
    });

    $mdl.on('change', '#skufwiz_data_confirm', updateNextBtnState);

    function calcTotal() {
        var $pkg = $mdl.find('input[name="skufwiz_pkg"]:checked').closest('.skufwiz-card');
        var pkg_net        = parseFloat($pkg.data('pkg-net'))       || 0;
        var pkg_brut       = parseFloat($pkg.data('pkg-brut'))      || 0;
        var pkg_net_orig   = parseFloat($pkg.data('pkg-net-orig'))  || pkg_net;
        var pkg_disc_perc  = parseFloat($pkg.data('pkg-disc-perc')) || 0;
        var pkg_disc_net   = parseFloat($pkg.data('pkg-disc-net'))  || 0;
        var pkg_disc_brut  = parseFloat($pkg.data('pkg-disc-brut')) || 0;
        var pkg_disc_label = $pkg.data('pkg-disc-label') || '';
        var pkg_name       = $pkg.find('.nm').text();
        var extras = [];
        var extras_net  = 0;
        var extras_brut = 0;
        $mdl.find('input[name^="skufwiz_child"]:checked').each(function() {
            var $e = $(this).closest('.skufwiz-extra');
            var net  = parseFloat($e.data('extra-net'))  || 0;
            var brut = parseFloat($e.data('extra-brut')) || 0;
            extras.push({ name: $e.find('.nm').text(), net: net, brut: brut });
            extras_net  += net;
            extras_brut += brut;
        });
        var net  = pkg_net  + extras_net;
        var brut = pkg_brut + extras_brut;
        var tax  = brut - net;
        return {
            pkg_name: pkg_name, pkg_net: pkg_net, pkg_brut: pkg_brut,
            pkg_net_orig: pkg_net_orig,
            pkg_disc_perc: pkg_disc_perc, pkg_disc_net: pkg_disc_net, pkg_disc_brut: pkg_disc_brut, pkg_disc_label: pkg_disc_label,
            extras: extras, net: net, tax: tax, total: brut
        };
    }

    function fmt(v) {
        return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function updateSidebar() {
        var c = calcTotal();
        $('#skufwiz_side_pkg_name').text(c.pkg_name);
        var html = '<div class="row-line"><span>'+c.pkg_name+'</span><span>'+fmt(c.pkg_net_orig)+'</span></div>';
        if (c.pkg_disc_perc > 0) {
            html += '<div class="row-line text-danger" style="padding-left:1em;"><span>−'+c.pkg_disc_label+' *</span><span>−'+fmt(c.pkg_disc_net)+'</span></div>';
        }
        c.extras.forEach(function(e) {
            html += '<div class="row-line muted"><span>'+e.name+'</span><span>'+fmt(e.net)+'</span></div>';
        });
        $('#skufwiz_side_lines').html(html);
        $('#skufwiz_net').text(fmt(c.net));
        $('#skufwiz_mwst').text(fmt(c.tax));
        $('#skufwiz_total').text(fmt(c.total));
    }

    function updateSummary() {
        var c = calcTotal();
        var pkg_html = '<div class="d-flex justify-content-between"><span>'+c.pkg_name+'</span><span class="font-weight-bold">'+fmt(c.pkg_net_orig)+'</span></div>';
        if (c.pkg_disc_perc > 0) {
            pkg_html += '<div class="d-flex justify-content-between text-danger" style="padding-left:1em;"><span>−'+c.pkg_disc_label+' *</span><span class="font-weight-bold">−'+fmt(c.pkg_disc_net)+'</span></div>';
        }
        var html = '<div class="skufwiz-sumc">'
                 + '<div class="lbl">Paket</div>'
                 + pkg_html
                 + '</div>';
        if (c.extras.length > 0) {
            html += '<div class="skufwiz-sumc"><div class="lbl">Zusatzleistungen</div>';
            c.extras.forEach(function(e) {
                html += '<div class="d-flex justify-content-between"><span>'+e.name+'</span><span class="font-weight-bold">'+fmt(e.net)+'</span></div>';
            });
            html += '</div>';
        }
        html += '<div class="skufwiz-sumc tot">'
              + '<div class="lbl">Gesamt brutto (inkl. MwSt.)</div>'
              + '<div class="d-flex justify-content-between align-items-baseline">'
              + '<span class="font-weight-bold">Endbetrag</span>'
              + '<span class="h3 mb-0 font-weight-bold">'+fmt(c.total)+'</span>'
              + '</div>'
              + '</div>';
        $('#skufwiz_summary').html(html);
    }

    function pkgChanged() {
        var $sel = $mdl.find('input[name="skufwiz_pkg"]:checked');
        $mdl.find('.skufwiz-card').removeClass('skufwiz-sel');
        $sel.closest('.skufwiz-card').addClass('skufwiz-sel');
        $('#skufwiz_skuf_id').val($sel.val());
        updateSidebar();
    }

    function extraChanged() {
        $mdl.find('.skufwiz-extra').each(function() {
            $(this).toggleClass('skufwiz-sel', $(this).find('input').prop('checked'));
        });
        updateSidebar();
    }

    $mdl.on('change', 'input[name="skufwiz_pkg"]', pkgChanged);
    $mdl.on('change', 'input[name^="skufwiz_child"]', extraChanged);

    $mdl.on('shown.bs.tab', '#skufwiz_auth_tabs a', function() {
        updateNextBtnState();
        if (JW && JW.Modal && JW.Modal.posMdl) JW.Modal.posMdl($mdl);
    });

    $mdl.on('change', '#reg_invfromaddr, #data_invfromaddr', function() {
        if (!JW || !JW.Modal || !JW.Modal.posMdl) return;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() { JW.Modal.posMdl($mdl); });
        });
    });

    $mdl.on('click', '#skufwiz_stepper > div.bck', function() {
        var s = parseInt($(this).data('step'), 10);
        if (!isNaN(s) && s < step) showStep(s);
    });

    $('#skufwiz_back').on('click', function(e) {
        // step === 0: let the global '.mdl-close-frc' handler close the modal
        if (step === 0) return;
        // step > 0: showStep() unten setzt die Klasse mdl-close-frc bei Rückkehr nach 0 wieder.
        // Ohne stopPropagation würde der globale Close-Handler am document beim selben Click
        // erneut prüfen und den (jetzt gesetzten) Selektor matchen → Modal würde schließen.
        e.stopPropagation();
        showStep(step - 1);
    });
    $('#skufwiz_next').on('click', function() {
        // step 2 (Anmeldung): trigger login_check / register_check passend zum aktiven Tab,
        // wenn dieser Tab noch nicht authed ist. Path A ($isc) hat keine Tabs → einfach weiter.
        if (step === 2) {
            var $loginPane = $mdl.find('#skufwiz_auth_login');
            if ($loginPane.length > 0)
            {
                var loginActive    = $loginPane.hasClass('active');
                var alreadyAuthed  = loginActive ? skufwiz_authed_1 : skufwiz_authed_2;
                if (!alreadyAuthed)
                {
                    $('#skufwiz_form_act').val(loginActive ? 'login_check' : 'register_check');
                    $(this).prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');
                    $('#frm_skufwiz').trigger('ev_form_submit');
                    return;
                }
            }
        }
        showStep(step + 1);
    });

    function skufwizErr(msg) {
        $('#skufwiz_msgs').html('<div class="alert alert-danger msg-i fade show"><i class="fa fa-exclamation"></i><div>'+msg+'</div></div>');
    }

    $('#skufwiz_submit').on('click', function() {
        if (!$('#skufwiz_agb').prop('checked')) {
            skufwizErr('Bitte AGB und Datenschutzerklärung akzeptieren.');
            return;
        }
        $('#skufwiz_msgs').html('');
        $(this).prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');
        $('#skufwiz_form_act').val('book');
        $('#frm_skufwiz').trigger('ev_form_submit');
    });

    $mdl.on('skufwiz_email_in_use', function() {
        $('#login_mail').val($('#reg_email').val());
        $mdl.find('a[href="#skufwiz_auth_login"]').tab('show');
        setTimeout(function() { $('#login_pass').focus(); }, 150);
    });

    $mdl.on('skufwiz_repos', function() {
        if (!JW || !JW.Modal || !JW.Modal.posMdl) return;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() { JW.Modal.posMdl($mdl); });
        });
    });

    showStep(0);
    updateSidebar();
};
